'use strict'

const state = {
  color: null,
  message: null,
  timeout: 0,
  isVisible: false
}

const actions = {
  show ({ commit }, payload) {
    commit('clear')
    setTimeout(() => { commit('show', payload) }, 100)
  },

  clear ({ commit }) {
    commit('clear')
  }
}

const mutations = {
  show (state, { type, message, timeout }) {
    state.color = type
    state.message = message
    state.timeout = timeout || 4000
    state.isVisible = true
  },

  clear (state) {
    state.color = null
    state.message = null
    state.timeout = 0
    state.isVisible = false
  }
}

const snackbar = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default snackbar
